import type { CriterionRating } from "@data/studios";
import styles from "./RatingPill.module.css";

interface RatingPillProps {
  label: string;
  rating: CriterionRating;
}

const RATING_LABELS: Record<CriterionRating, string> = {
  exceptional: "Exceptional",
  excellent: "Excellent",
  strong: "Strong",
  solid: "Solid",
};

export function RatingPill({ label, rating }: RatingPillProps) {
  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>
      <span className={`${styles.pill} ${styles[rating]}`}>{RATING_LABELS[rating]}</span>
    </div>
  );
}
